<template>
  <div class="blocks">
    <div class="top">当前状态
      <select>
        <option value ="volvo">自动</option>
        <option value ="saab">手动</option>
      </select>
    </div>
    <div class="blossomVideo">
      <div class="operation">
        <div class="opessmoll"></div>
        <div class="describe">运行状态
        </div>
        <div class="opesimg">{{vediourl.status}}</div>
      </div>
       <div class="task" >
        <div class="opessmoll "></div>
        <span class="opessmollbg">当前执行任务</span>
        <div class="vediourl">所属订单 : <span class="indent">{{vediourl.indent}}</span> </div>
         <div class="vediourl">任务编号 : <span class="indent">{{vediourl.serial}}</span> </div>
      </div>
      <div class="datadetails">
          <span class="voltage">
              <div class="changedata">{{vediourl.voltage}}v</div>
              <span class="fixation">电压</span>
          </span>
          <span class="voltage">
              <div class="changedata">{{vediourl.electricity}}v</div>
              <span class="fixation">电流</span>
          </span>
          <span class="voltage">
              <div class="changedata">{{vediourl.temperature}}℃</div>
              <span class="fixation">核心温度</span>
          </span>
          <span class="rev">
               <div class="changedata">{{vediourl.rev}}R/s</div>
              <span class="fixation">核心转速</span>
          </span>
      </div>
    </div>
  </div>
</template>
<script>
//这是设备维保当前状态组件
export default {
  name: "echarts13",
  props: {
    vediourl: {
      type: Object,
      default:()=> {
          return {
              status:"运行",
              indent:"3349582049204",
              serial:"33333",
              voltage:"320",
              electricity:"432",
              temperature:"565",
              rev:"3543"
          }
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style  scoped>
.blocks {
  width: 318px;
  height: 230px;
  position: relative;
}
.top {
  position: absolute;
  left: 85px;
  top: -12px;
  width: 150px;
  height: 32px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  border-radius: 8px;
}
.blossomVideo {
  width: 300px;
  height: 210px;
  position: absolute;
  top: 22px;
  left: 9px;
  border-radius: 6px;
}
.operation {
  width: 100%;
  height: 57px;
  line-height: 57px;
  display: flex;
}
.describe {
  color: #fff;
  line-height: 57px;
  margin: 0 10px
}
.operation .opessmoll {
  width: 16px;
  height: 9px;
  margin-top: 23px;
  background: url("../../assets/img/echarts13-1.png") no-repeat;
}
.operation .opesimg {
  width: 59px;
  height: 57px;
  background: url("../../assets/img/echarts13-0.png") no-repeat;
  text-align: center;
  line-height: 57px;
  font-weight: 500;
  color: #fff;
}
.task {
    width: 100%;
    height: 80px;
}
.task .opessmoll {
    display: inline-block;
    width: 16px;
    height: 9px;
    background: url("../../assets/img/echarts13-1.png") no-repeat;
}
.opessmollbg {
    color: #fff;
}
.vediourl {
    color: #00E4FF;
    margin-top: 4px;
    margin-left: 20px;
    font-weight: 600
}
.indent {
    color: #fff;
    font-weight: 500
}
.datadetails {
    margin-top: 5px;
    width: 100%;
    height: 52px;
    display: flex
}
.voltage {
    width: 70px;
    height: 51px;
    display: inline-block;
    position: relative;
    background: url("../../assets/img/echarts13-2.png")no-repeat
}
.rev {
    width: 83px;
    height: 51px;
    display: inline-block;
    position: relative;
    background: url("../../assets/img/echarts13-3.png")no-repeat
}
.fixation {
    position: absolute;
    font-size: 10px;
    bottom:4px;
    width: 100%;
    color: #A0D3E3;
    text-align: center;
    left: 4px;
}
.changedata {
    line-height: 50px;
    text-align: center;
    color: #DBE23E;
    font-weight: 600;
    margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts11.vue